import api from '../utils/api';

class ReviewApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/reviews', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise((resolve, reject) => {
      return api
        .post('/reviews', data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/reviews/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/reviews/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  approved = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/reviews/publish/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/reviews/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  handleApprove = (ids) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/reviews/approve`, { ids });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const reviewApi = new ReviewApi();
export default reviewApi;
